import { render, staticRenderFns } from "./DepTable.vue?vue&type=template&id=2ee09f1b&scoped=true"
import script from "./DepTable.vue?vue&type=script&lang=js"
export * from "./DepTable.vue?vue&type=script&lang=js"
import style0 from "./DepTable.vue?vue&type=style&index=0&id=2ee09f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee09f1b",
  null
  
)

export default component.exports